import { Box, HStack, Image, ModalCloseButton, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import AddBusinessImg from '../../../assets/images/add-business-briefcase.svg';
import {
  AnimatedLogo,
  CustomModalClosePrimaryButton,
  CustomModalFooter,
  PrimaryButton,
  SecondaryButton,
} from '../../../components/custom';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { resetBusinessAddition } from '../../../store/slices/business/addNewBusinessSlice';

export default function AddNewBusinessConfirmation({
  onClose,
}: {
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const { status, value } = useAppSelector((state) => state.userBusinesses);
  const hasBusinessPendingAccountActivation = value?.data?.some(
    (business) => !business.hasAccount
  );

  const handleAddNewBusiness = () => {
    onClose();
    appDispatch(resetBusinessAddition());
    localStorage.removeItem('businessId');
    localStorage.removeItem('businessName');

    navigate('/app/compliance?action=add_new_business');
  };

  if (status === 'loading') {
    <>
      <AnimatedLogo />
    </>;
  }

  return (
    <>
      {hasBusinessPendingAccountActivation ? (
        <Box>
          <Box pt={10} pb={4}>
            <Image
              src={AddBusinessImg}
              alt=""
              role="presentation"
              loading="lazy"
              boxSize={138.5}
              mx="auto"
              mb={4}
            />
            <Text fontSize="24px" lineHeight="133%" textAlign="center" mb={3}>
              Pending Business Activation
            </Text>
            <Text color="gray.200" textAlign="center" letterSpacing="-0.12px">
              You have a business pending activation and cannot create a new
              one. Complete the setup or try again later.
            </Text>
          </Box>
          <CustomModalFooter>
            <CustomModalClosePrimaryButton w="full" as={ModalCloseButton}>
              Dismiss
            </CustomModalClosePrimaryButton>
          </CustomModalFooter>
        </Box>
      ) : (
        <Box>
          <Box pt={10} pb={4}>
            <Image
              src={AddBusinessImg}
              alt=""
              role="presentation"
              loading="lazy"
              boxSize={138.5}
              mx="auto"
              mb={4}
            />
            <Text fontSize="24px" lineHeight="133%" textAlign="center" mb={3}>
              Add New Business
            </Text>
            <Text color="gray.200" textAlign="center" letterSpacing="-0.12px">
              Creating a new business would require a different business name
              and registration information. Would you like to proceed?
            </Text>
          </Box>
          <CustomModalFooter>
            <HStack spacing={4}>
              <PrimaryButton w="full" onClick={handleAddNewBusiness}>
                Yes, Proceed
              </PrimaryButton>
              <SecondaryButton
                w="full"
                as={ModalCloseButton}
                top="initial"
                right="initial"
                flexShrink="initial"
              >
                No, Cancel
              </SecondaryButton>
            </HStack>
          </CustomModalFooter>
        </Box>
      )}
    </>
  );
}
